import { isArray } from 'lodash'

const currentLogLevel
  = process.env.LOG_LEVEL && process.env.LOG_LEVEL !== 'undefined' ? process.env.LOG_LEVEL : 'info'

export default function LoggingMixin (BaseClass = class {}) {
  const Mixin = class extends BaseClass {
    static logLevels = ['debug', 'info', 'log', 'warn', 'error']

    constructor (...args) {
      super(...args)
      this.constructor.logLevels.forEach((level) => {
        this[level] = (...messageArgs) => this.constructor[level](...messageArgs)
      })
    }

    static shouldLog (level) {
      return this.logLevels.indexOf(level) >= this.logLevels.indexOf(currentLogLevel)
    }

    static get _log_name () {
      if (this.__log_name) {
        return this.__log_name
      }

      return this.name
    }

    static set _log_name (args) {
      if (!isArray(args)) {
        this.__log_name = args
        return
      }

      this.__log_name = args.map((arg) => {
        if (arg instanceof String) {
          return `[${arg}]`
        } else {
          return arg
        }
      })
    }
  }

  Mixin.logLevels.forEach((level) => {
    Mixin[level] = function (...args) {
      if (Mixin.shouldLog(level)) {
        console[level](this._log_name, ...args) // TODO: stack
      }
    }
  })

  return Mixin
}
